import Swal from 'sweetalert2'

const alert = Swal.mixin({})

export const Alert = (success = true, message = '', duration = 6000) => {
  let type
  if (typeof success === 'boolean') {
    type = success ? 'success' : 'error'
  } else {
    type = success
  }

  alert.fire({
    icon: type,
    title: message,
    // toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: duration,
    timerProgressBar: true,
    iconColor: 'white',
    customClass: {
      popup: 'vn-toast-popup',
      container: 'vn-toast',
    },
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
      toast.addEventListener('click', Swal.close)
    },
  })
}

export const getAttributesString = (atts) => {
  if (typeof atts === 'string') {
    return atts.split(' ').map(encodeURIComponent).join('+')
  }

  const encodedArr = atts.map((att) => {
    return att.split(' ').map(encodeURIComponent).join('+')
  })

  return encodedArr.reduce((acc, el) => {
    return `${acc},${el}`
  })
}

export const getAttributeName = (slug) => {
  return slug.split('+').map(decodeURIComponent).join(' ')
}

export const dynamicUriTemplate = (baseUri, params, mainSlug, slugs) => {
  const empty = Object.keys(params).every((param) => {
    return params[param] === undefined || params[param] === ''
  })

  if (empty) {
    return mainSlug !== '' ? `${baseUri}/${mainSlug}/` : baseUri
  }

  let templateString = mainSlug !== '' ? `${baseUri}/${mainSlug}` : baseUri

  for (const key in params) {
    if (params[key]?.length > 0) {
      templateString += `/${slugs[key]}/${getAttributesString(params[key])}`
    }
  }

  return templateString + '/'
}

export const extractParamsFromUri = (url, slugs) => {
  const urlObj = new URL(url)
  const pathSegments = urlObj.pathname.split('/').filter(Boolean)

  let attributes = {}

  for (let i = 0; i < pathSegments.length; i++) {
    if (Object.values(slugs).includes(pathSegments[i])) {
      let value = pathSegments[i + 1]

      attributes[pathSegments[i]] = value.includes(',')
        ? value.split(',').map((el) => getAttributeName(el))
        : [value].map((el) => getAttributeName(el))
    }
  }

  return attributes
}

export const isTouchDevice =
  'ontouchstart' in window || navigator.msMaxTouchPoints
